export const roleAtCompany: string[] = ['product designer', 'developer'];
export const employeesQuantity: string[] = ['10+', '50+', '100+', '200+'];
export const companyDepartment: string[] = ['product', 'sales', 'it'];

export const subdomainPopoverList: string[] = [
  'Lowercase letters (a to z)',
  'Numbers',
  'Hyphens'
];
